export default function GiftSection({ gifts, setGifts }) {
	const handleChange = (e) => {
		const { name, value } = e.target;

		setGifts((prevState) => {
			return {
				...prevState,
				[name]: value
			};
		});
	};

	return (
		<div className="px-4 py-5 " data-sentry-component="GiftSection" data-sentry-source-file="index.jsx">
			<h2 className="border-b-2 mb-4 col-span-6 md:text-2xl font-semibold">
				Gift Request
			</h2>
			<div className="border border-gray-100 box-border gap-6 grid grid-cols-8 md:mt-4 mt-8 p-3 pl-3 relative rounded-sm shadow-md">
				<div className="col-span-8 md::col-span-4 ">
					<label
						htmlFor="gift"
						className="block text-sm font-medium text-gray-700"
					>
						Gift
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						name="gift"
						value={gifts.gift}
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>

				<div className="col-span-4 sm:col-span-3 ">
					<label
						htmlFor="shirt"
						className="block text-sm font-medium text-gray-700"
					>
						Shirt Size
					</label>
					<input
						onChange={(e) => handleChange(e)}
						value={gifts.shirt}
						type="text"
						name="shirt"
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>
				<div className="col-span-4 sm:col-span-3 ">
					<label
						htmlFor="pant"
						className="block text-sm font-medium text-gray-700"
					>
						Pant Size
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						name="pant"
						value={gifts.pant}
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>
				<div className="col-span-4 sm:col-span-2 ">
					<label
						htmlFor="shoe"
						className="block text-sm font-medium text-gray-700"
					>
						Shoe Size
					</label>
					<input
						onChange={(e) => handleChange(e)}
						value={gifts.shoe}
						type="text"
						name="shoe"
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>
				<div className="col-span-6 sm:col-span-4">
					<label
						htmlFor="deliveryLocation"
						className="block text-sm font-medium text-gray-700"
					>
						Delivery Location
					</label>
					<select
						onChange={(e) => handleChange(e)}
						name="deliveryLocation"
						className="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-hidden focus:ring-emerald-300 focus:border-emerald-300 sm:text-sm rounded-md"
						defaultValue="Choose"
					>
						<option disabled>Choose</option>
						<option>Distribution Center</option>
						<option>Bradford Ecumenical Home</option>
						<option>Chapel Ridge</option>
						<option>Bradford Senior Activity Center</option>
						<option>Emery Towers Senior Apartments</option>
						<option>Bradford High Rise Apartments</option>
						<option>Special Delivery Request</option>
					</select>
				</div>
				{gifts.deliveryLocation === 'Special Delivery Request' ? (
					<div className="col-span-6 sm:col-span-4">
						<div className="col-span-6 sm:col-span-4">
							<label
								htmlFor="specialRequest"
								className="block text-sm font-medium text-gray-700"
							>
								Explain your situation
							</label>
							<input
								onChange={(e) => handleChange(e)}
								value={gifts.specialRequest}
								type="text"
								name="specialRequest"
								className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
							/>
						</div>
						<div className="pl-2 col-span-12 sm:col-span-4 text-red-400 mt-1">
							Home deliveries will be considered ONLY for extreme
							circumstances.
						</div>
					</div>
				) : null}
			</div>
		</div>
	);
}
